import { createLogger } from 'logger-js'
import pageViewAnalyticsUtil from 'modules/analytics/utils/page-view'
import React from 'react'
import useDispatch from 'modules/component/utils/hooks/useDispatch.js'
import useSelector from 'modules/component/utils/hooks/useSelector.js'
import getLocationRouterSelect from 'modules/router/selectors/get-location'

const logger = createLogger({
  label: 'LocationListener'
})

function afterFirstNavigation (location, action) {
  return async (dispatch) => {
    try {
      const afterFirstNavigationClientHook = await import(/* webpackChunkName: "client/hooks/after-first-navigation" */ 'client/hooks/after-first-navigation')
      return dispatch(
        afterFirstNavigationClientHook.default(location, action)
      )
    } catch (error) {
      logger.error('after first navigation failed: ', error)
    }
  }
}

function onHistoryListen (location) {
  pageViewAnalyticsUtil(location.pathname)
}

let navigationCount = 0

function onHistoryChangeProxy (location) {
  return (dispatch) => {
    if (navigationCount === 1) {
      dispatch(afterFirstNavigation())
    }
    onHistoryListen(location)
    navigationCount += 1
  }
}

function usePageViews () {
  const dispatch = useDispatch()
  const location = useSelector(getLocationRouterSelect)
  React.useEffect(() => {
    dispatch(onHistoryChangeProxy(location))
  }, [location])
}

function LocationListener () {
  if (BROWSER) {
    usePageViews()
  }
  return <></>
}

export default LocationListener
